var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstrument3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 565.51 565.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e1b16;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tamb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499,184s-17-42-27-54c0,0,31-50-16-85,0,0-46-23-73,13,0,0-149-38-265,109,0,0-72,83-50,203,0,0-36,25-11,83,0,0,25,35,78,12,0,0,33,24,54,28,0,0,3,28,57,34,0,0,37-6,49-34,0,0,53-19,85-45,0,0,42,9,62-21,0,0,17-11,15-52,0,0,31-49,36-74,0,0,42-11,43-65C536,236,538,199,499,184ZM393,320s-49,76-122,95c0,0-104,50-168-31,0,0-42-49-5-145,0,0,10-47,80-107,0,0,75-75,183-55,0,0,67,15,78,94C439,171,452,253,393,320Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrument3);
export default __webpack_public_path__ + "static/media/instrument-3.add3e36244f945c5573dcfe2f31da70d.svg";
export { ForwardRef as ReactComponent };